/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'less': {
    width: 32,
    height: 32,
    viewBox: '0 -1 32 31',
    data: '<g transform="translate(-4.003)" _fill="none" fill-rule="evenodd" _stroke="none" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="none"><g transform="translate(18 12)" _stroke="#03272e"><polyline pid="0" transform="rotate(90 2 4)" points="6 0 2 8 -2 0"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/less.js